import React from 'react';
export function AnnouncementBar() {
  const text = 'BIENVENID@S \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0 OFERTA POR TIEMPO LIMITADO DEL 60%';
  return <div className="bg-partyPink-hot text-white py-2 overflow-hidden whitespace-nowrap relative z-50" data-id="element-23">
      <div className="animate-marquee inline-flex gap-16" data-id="element-24">
        <span className="font-bold text-sm tracking-widest uppercase" data-id="element-25">
          {text}
        </span>
        <span className="font-bold text-sm tracking-widest uppercase" data-id="element-26">
          {text}
        </span>
        <span className="font-bold text-sm tracking-widest uppercase" data-id="element-27">
          {text}
        </span>
        <span className="font-bold text-sm tracking-widest uppercase" data-id="element-28">
          {text}
        </span>
      </div>
    </div>;
}